//该文件注册当前服务内，通用的组件注册
  //示例组件注册
  import copyEmptySelect from './select/copyEmptySelect.vue'
  import recordSetSelect from './select/recordSetSelect.vue'
  
  import enterGroupRadio from './select/enterGroupRadio.vue'


  import checkItem from './form/checkItem.vue'
  export default {
    copyEmptySelect,
    recordSetSelect,
    enterGroupRadio,
    checkItem
  }
